"use strict";

define('evisions/helper/array',['underscore', 'evisions/helper/defer', 'evisions/helper/test'], function (_, EVIHelperDefer, EVIHelperTest) {
  var EVIHelperArray = _.extend({
    contains: _.contains,
    pluck: _.pluck,
    cloneArray: function cloneArray(arr, deep) {
      if (deep === true) {
        var i = 0,
          len = arr.length,
          newArr = [],
          item = null;
        for (i = 0; i < len; ++i) {
          item = arr[i];
          if (this.isArray(item)) {
            newArr.push(this.cloneArray(item, deep));
          } else {
            newArr.push(item);
          }
        }
        return newArr;
      }
      return arr.slice(0);
    },
    invoke: function invoke() {
      return _.invoke.apply(_, arguments);
    },
    forEachSeries: function forEachSeries(models, cb) {
      var d = Promise.defer(),
        currentD = null,
        index = 0,
        _resolver = null;
      cb = EVIHelperTest.makeFunction(cb);
      _resolver = function resolver() {
        if (index === models.length) {
          d.resolve();
        }
        currentD = cb(models[index], index);
        index++;
        if (currentD && currentD.done && currentD.fail) {
          currentD.fail(d.reject).then(_resolver);
        } else {
          _resolver();
        }
      };
      _resolver();
      return d.promise;
    },
    sortByFunction: function sortByFunction(items, parser, type, reverse) {
      var newItems = [];
      type = type || 'String';
      newItems = _.sortBy(items, function (item) {
        var val = parser(item);
        if (type == 'String') {
          val = val ? val : '     ';
          return val.toUpperCase();
        } else {
          return val;
        }
      });
      if (reverse == 'desc') {
        newItems.reverse();
      }
      return newItems;
    },
    sortByProperty: function sortByProperty(items, prop, type, reverse) {
      var newItems = _.sortBy(items, function (item) {
        var val = _.isFunction(prop) ? item.prop() : item[prop];
        if (type == 'String') {
          val = val ? val : '     ';
          return val.toUpperCase();
        } else {
          return val;
        }
      });
      if (reverse == 'desc') {
        newItems.reverse();
      }
      return newItems;
    },
    sortByColumn: function sortByColumn(data, column, type, reverse) {
      var temp = null;
      if (type == 'Int') {
        temp = Array.prototype.valueOf;
        Array.prototype.valueOf = function () {
          return this[column];
        };
        data.sort(function (a, b) {
          return a - b;
        });
        Array.prototype.valueOf = temp;
      } else if (type == 'String' || type == 'Date') {
        temp = Array.prototype.valueOf;
        Array.prototype.toString = function () {
          return this[column];
        };
        data.sort();
        Array.prototype.toString = temp;
      }
      if (reverse == 'desc') {
        data.reverse();
      }
    }
  });
  return EVIHelperArray;
});

